import React, { useState, useEffect } from 'react';
import { pushNotificationManager } from '../../utils/notifications/pushManager';

const NotificationPermissionBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if we should show the banner
    const checkPermission = async () => {
      const permission = pushNotificationManager.getPermissionStatus();
      const hasSeenBanner = localStorage.getItem('notificationBannerDismissed');
      
      // Show banner if permission is default (not yet asked) and user hasn't dismissed it
      if (permission === 'default' && !hasSeenBanner) {
        setShowBanner(true);
      }
    };

    checkPermission();
  }, []);

  const handleEnable = async () => {
    setIsLoading(true);
    try {
      await pushNotificationManager.requestAndSubscribe();
      setShowBanner(false);
      localStorage.setItem('notificationBannerDismissed', 'granted');
    } catch (error) {
      console.error('Failed to enable notifications:', error);
      // If denied, hide banner
      if (pushNotificationManager.getPermissionStatus() === 'denied') {
        setShowBanner(false);
        localStorage.setItem('notificationBannerDismissed', 'denied');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('notificationBannerDismissed', 'dismissed');
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-lg">
      <div className="max-w-6xl mx-auto px-4 py-4 sm:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 text-2xl">
              🔔
            </div>
            <div className="flex-1">
              <h3 className="text-sm font-semibold text-slate-900">
                Enable Notifications
              </h3>
              <p className="mt-1 text-sm text-slate-600">
                Get notified about new messages, appointments, and important updates even when the app is closed.
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <button
              onClick={handleDismiss}
              className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 transition"
              disabled={isLoading}
            >
              Not now
            </button>
            <button
              onClick={handleEnable}
              disabled={isLoading}
              className="px-4 py-2 text-sm font-semibold text-white bg-[#4f7a64] hover:bg-[#3d6350] rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Enabling...' : 'Enable'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationPermissionBanner;
